export default function classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/shared/classes-to-selector.js
// module id = 310
// module chunks = 9